import { render, staticRenderFns } from "./ArtworkRow.vue?vue&type=template&id=8f445756&scoped=true&"
import script from "./ArtworkRow.vue?vue&type=script&lang=js&"
export * from "./ArtworkRow.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/listrows.css?vue&type=style&index=0&id=8f445756&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f445756",
  null
  
)

export default component.exports